export const ratingFontSizeStyles = (
  expandedProviderListView,
  TabletScreen,
  isGEHAV2
) => ({
  'abyss-rating-text': {
    color: isGEHAV2 ? '$primary1' : '',
    fontSize: expandedProviderListView ? (TabletScreen ? '16px' : '18px') : '',
  },
});

export const groupedPinRatingStyles = (notXlScreen) =>
  notXlScreen && {
    'abyss-rating-stars-container': {
      width: '80px',
    },
    'abyss-rating-star': {
      width: '16px',
    },
    'abyss-rating-text': {
      fontSize: '14px',
      fontWeight: '400',
    },
  };

export const additionalRatingStyle = (expandedProviderListView) => ({
  minWidth: expandedProviderListView ? 'max-content' : '',
});
